import React from 'react';

import './index.scss';

const Location = () => {
	return (
		<div className='contact-section-wrapper'>
			<h3>Location</h3>
			<div className='contact-card location-card'>
				<h4 className='location-title'>Amy's Nails & Spa</h4>
				<p>68 Merrick Road</p>
				<p>Amityville, NY 11701</p>
			</div>
			<div className='map'>
				<iframe
					src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2658.8373307942056!2d-73.42219417087!3d40.6716491163282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e9d5aafc49aaaf%3A0xf81c0248aec4fdd!2s68%20Merrick%20Rd%2C%20Amityville%2C%20NY%2011701!5e0!3m2!1szh-CN!2sus!4v1604294810002!5m2!1szh-CN!2sus'
					width='90%'
					height='250'
					frameborder='0'
					title='navigation'
				></iframe>
			</div>
		</div>
	);
};

export default Location;
